import React, {ReactNode} from "react"
import {Container} from "./component"

export type StandardContainerProps = {
    alignment: string
    loaded: boolean
    onScroll: () => void
    reference: React.RefObject<HTMLUListElement>
    alignmentCSS: string
    children: ReactNode
}

export const StandardContainer = ({
    alignment,
    loaded,
    onScroll,
    reference,
    alignmentCSS,
    children,
}: StandardContainerProps) => {
    return (
        <Container
            alignment={alignment}
            data-testid="snail-trail-container"
            id="snail-trail-container"
            loaded={loaded}
            onScroll={onScroll}
            ref={reference}
            style={{
                justifyContent: alignmentCSS,
            }}
        >
            {children}
        </Container>
    )
}

export default StandardContainer
